export default function auth({ next, to }) {
  try {
    const user = JSON.parse(window.localStorage.getItem("auth.currentUser"));
    if (!user || !user.token) {
      throw false;
    } else {
      return next();
    }
  } catch (e) {
    return next({
      name: "loginPage",
      query: { reditect: to.path }
    });
  }
}
// implement pipelines for more than one middleware
//https://blog.logrocket.com/vue-middleware-pipelines/

export function isLogged() {
  try {
    const user = JSON.parse(window.localStorage.getItem("auth.currentUser"));
    if (!user || !user.token) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    window.localStorage.setItem("auth.currentUser", null);
    return false;
  }
}
